import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';
import './modules/register-service-worker';
import navigation from './modules/nagivation';
import ga4 from './modules/ga4';
import multiselect from './modules/multiselect'; // Multiselects should be created as early as possible (as in not lazyloaded) because a lot of functionality depend on these

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init();
navigation.init();

const formElement = document.querySelector('form');
if (formElement) {
  multiselect.init();

  const searchWatcherElement = document.getElementById('vehicle-search-watcher-form');
  if (searchWatcherElement) {
    import('./modules/search-watcher').then((searchWatcher) => searchWatcher.default.init());
  }

  const vehicleSearchElement = document.getElementById('vehicle-search');
  if (vehicleSearchElement) {
    import('./modules/vehicle-search').then((vehicleSearch) => vehicleSearch.default.init());
  }

  const selectFilters = document.querySelector('.js-filter-models');
  if (selectFilters) {
    import('./modules/filter-select').then((fs) => fs.default.init());
  }

  //init number range
  import('./modules/number-range').then((range) => {
    range.default.init();
  });

  //init stage forms
  import('./modules/stage-forms').then((stageForms) => {
    stageForms.default.init();
  });
}

const heroVehicleSearchElement = document.querySelector('.hero-vehicle-search');
if (heroVehicleSearchElement) {
  import('./modules/hero-vehicle-search').then((heroVehicleSearch) => heroVehicleSearch.default.init());
}

const cardCarouselElement = document.querySelector('.card-carousel');
if (cardCarouselElement) {
  import('./modules/card-carousel').then((cardCarousel) => cardCarousel.init());
}

const accordionElement = document.querySelector('.js-accordion');
if (accordionElement) {
  import('./modules/accordion').then(({ default: Accordion }) => Accordion.init());
}

const vehicleImageCarousel = document.querySelector('.vehicle-image-carousel');
if (vehicleImageCarousel) {
  if (heroVehicleSearchElement) {
    const options = {
      type: 'carousel',
      focusAt: 'center',
      startAt: 0,
      perView: 1,
      peek: 0,
      gap: 8,
      keyboard: true, //keyboard arrows controlled carousel even if it was not selected
    };
    import('./modules/vehicle-image-carousel').then((vehicleImageCarousel) => vehicleImageCarousel.init(options));
  } else {
    import('./modules/vehicle-image-carousel').then((vehicleImageCarousel) => vehicleImageCarousel.init());
  }
}

const swiperCarousel = document.querySelector('.swiper');
if (swiperCarousel) {
  import('./modules/swiper-carousel').then((carousel) => carousel.init());
}

const vehiclePage = document.querySelector('.vehicle-page');
if (vehiclePage) {
  import('./modules/tabbed-details').then((tabbedDetails) => tabbedDetails.default.init());
  if (document.getElementById('funding-calculator')) {
    import('./modules/funding-calculator').then((fundingCalculator) => fundingCalculator.default.init());
  }
}

if (document.querySelector('#testDriveDialog')) {
  import('./modules/test-drive-dialog').then((testDriveDialog) => testDriveDialog.default.init());
}

if (document.querySelector('.vehicle-page__color-picker-dialog')) {
  import('./modules/vehicle-page-color-picker-dialog').then((colorPickerDialog) => colorPickerDialog.default.init());
}

if (document.getElementById('finance-form')) {
  import(/* webpackChunkName: 'financing-form' */ './modules/financing-form').then(({ default: initFinancingForm }) => {
    initFinancingForm();
    console.log('[OK] initFinancingForm()');
  });
}

if (document.querySelector('#sell-your-vehicle-form')) {
  import('./modules/sell-your-vehicle-form').then(({ default: initSellYourVehicleForm }) => {
    initSellYourVehicleForm();
  });
}

const ajaxForms = document.getElementsByClassName('ajax-form');

if (ajaxForms.length) {
  import('./modules/ajax-form').then(({ default: AjaxForm }) => {
    Array.from(ajaxForms).forEach((form) => new AjaxForm(form));
  });
}

//if lainalaskuri is present import and init
const lainalaskuri = document.getElementById('lainalaskuri');
if (lainalaskuri) {
  import('./modules/lainalaskuri');
}

const campaigns = document.querySelector('.campaigns');
if (campaigns) {
  import('./modules/campaign').then((campaign) => campaign.campaign());
}

const messageBars = document.querySelectorAll('.messagebar');

if (messageBars.length > 0) {
  import('./modules/messagebar').then(({ default: Messagebar }) => {
    messageBars.forEach((element) => {
      console.log(Messagebar);
      const messagebar = new Messagebar(element);
      messagebar.show();
    });
  });
}

if (document.querySelector('.js-cm-token')) {
  import('./modules/inject-cm-token').then(({ default: InjectCMToken }) => {
    InjectCMToken.init();
  });
}

ga4.init();
